import { FC, useContext } from "react";

import { TeamContext } from "../../../context";
import { IPlayer } from "../../../interfaces";

import { useEffect } from "react";
import { Phase } from "../../../util/enums";
import { useState } from "react";
import { getDilemmaOwnerCrownImage } from "./helpers";


interface IDilemmaOwnerCrown {
    angleInDegrees: number;
    angleInRadians: number;
    player: IPlayer | undefined;
}

const DilemmaOwnerCrown: FC<IDilemmaOwnerCrown> = (props) => {
    const { angleInDegrees, angleInRadians, player } = props;
    const { game } = useContext(TeamContext);
    const criticalAvatarPositionOf180Degrees : number = Math.sin(angleInRadians / 2);
    const isAvatarAtCriticalPosition : boolean = criticalAvatarPositionOf180Degrees > 0.99;
    const [crownBasedOnUserColor, setCrownBasedOnUserColor] = useState(getDilemmaOwnerCrownImage(player?.color || "pink", "initial", angleInDegrees));
    const [crownType, setCrownType] = useState<string>("initial");

    useEffect( () => {
        if(game?.phase === Phase.ACTION_CARD){
            setCrownType("action");
            setCrownBasedOnUserColor(getDilemmaOwnerCrownImage(player?.color || "pink", "action", angleInDegrees));
        }
        if(game?.phase === Phase.QUESTION_CARD || game?.phase === Phase.CHOOSE_SOLUTION || game?.phase === Phase.RENDER_SPIN_WHEEL || game?.phase === Phase.NINE){
            setCrownType("question")
            setCrownBasedOnUserColor(getDilemmaOwnerCrownImage(player?.color || "pink", "question", angleInDegrees));
        }
        if(game?.phase === Phase.CHOOSING_SOLUTION_CARDS || game?.phase === Phase.PICK_DILEMMA){
            setCrownType("initial")
            setCrownBasedOnUserColor(getDilemmaOwnerCrownImage(player?.color || "pink", "initial", angleInDegrees));
        }
        
    }, [game, angleInDegrees, crownType, player?.color])

    if (!player)
        return null;

    if (game?.gameInfo.currentPlayerEmail !== player.email)
        return null;

    if (angleInDegrees === 180){
        return (
            <div className={`${isAvatarAtCriticalPosition ? "crown_wrapper_left_side" : "crown_wrapper_right_side"}`}>
                <img
                    className="crown_image_right"
                    src={crownBasedOnUserColor}
                    alt="Profile Icon"
                />
            </div>
        )
    }

    return (
        <div className={`${isAvatarAtCriticalPosition ? "crown_wrapper_left_side horizontal_mirror_effect" : "crown_wrapper_right_side"}`}>
            <img
                className="crown_image_left"
                src={crownBasedOnUserColor}
                alt="Profile Icon"
            />
        </div>
    )
}

export default DilemmaOwnerCrown;